import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import withSounds from 'containers/withSounds';
import Input from 'components/Input';
import LoadingIndicator from 'components/LoadingIndicator';
import { isLocationPls } from 'utils/locations';
import { hasPatronAccount } from 'utils/roles';
import PurpleWIcon from 'resources/PurpleW.png';
import UberIcon from 'resources/icon-uber.png';
import WStoreGems from '../../WStoreGems';
import {
  getAvailableInfo,
  getCategoryItemClassName,
  getCategoryLogo,
  getLocationImage,
  getStockInfo,
  getValidityString,
  isPurchaseEnabled,
  isUber
} from '../../WStoreUtils';
import WStoreConfirmation from '../WStoreConfirmation';
import ExitButtonIcon from '../assets/Button-CloseModal-Red.png';
import './WStorePurchaseModal.css';

const BtnWithSounds = withSounds({ mouseEnterSound: true })(Button);

const RenderItemImage = ({ selectedItem }) => (
  <div className="item-image-column">
    <img
      className="item-image"
      src={selectedItem.imageUrl || PurpleWIcon}
      alt={selectedItem.name}
    />
    <img
      className="category-image"
      src={getCategoryLogo(selectedItem.classCode)}
      alt={selectedItem.classCode}
    />
    {getLocationImage(selectedItem)}
  </div>
);

const RenderUberItemImage = ({ selectedItem }) => (
  <div className="item-image-column">
    <img
      className="item-image"
      src={selectedItem.imageUrl || UberIcon}
      alt={selectedItem.name}
    />
  </div>
);

class WStorePurchaseModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPlsConfirmationModal: false,
      isModalPreferenceChecked: false
    };
  }

  renderPurchaseBody() {
    const { selectedItem, purchaseRequested } = this.props;
    const RenderImage = isUber(selectedItem)
      ? RenderUberItemImage
      : RenderItemImage;

    return (
      <React.Fragment>
        <div className="body-row">
          <RenderImage selectedItem={selectedItem} />
          <div className="item-info">
            <div className="description-title">Redeem your WScore points</div>
            <div className="separator" />
            <div className="item-description">
              <p>{selectedItem.description}</p>
              {isUber(selectedItem) && <p>{selectedItem.termsAndConditions}</p>}
            </div>
            <div className="separator" />
          </div>
        </div>
        <div className="body-row">
          <div className="item-count-validity">
            {getStockInfo(selectedItem.wstoreItemCount, true)}
            {getAvailableInfo(selectedItem.wstoreItemCount)}
            <div className="valid-dates">{getValidityString(selectedItem)}</div>
          </div>
        </div>
        <div className="wscore-info">
          <WStoreGems item={selectedItem} />
        </div>
        {purchaseRequested && <LoadingIndicator overlay />}
      </React.Fragment>
    );
  }

  renderRedeemButton() {
    const { selectedItem, patronAssets, onPurchase, user } = this.props;

    const onRedeemClicked = e => {
      const showPlsConfirmation =
        hasPatronAccount(user) &&
        isLocationPls(user.preferredLocation) &&
        !localStorage.getItem('showPlsConfirmation');

      if (showPlsConfirmation) {
        this.setState({
          showPlsConfirmationModal: true
        });
      } else {
        return onPurchase(e);
      }
    };

    const buttonLabel = 'Redeem';
    if (isPurchaseEnabled(selectedItem, patronAssets)) {
      return (
        <BtnWithSounds variant="success" onClick={onRedeemClicked}>
          {buttonLabel}
        </BtnWithSounds>
      );
    } else {
      return (
        <BtnWithSounds className="btn-redeem-disabled" variant="custom">
          {buttonLabel}
        </BtnWithSounds>
      );
    }
  }

  renderPlsConfirmationModal() {
    const { onPurchase } = this.props;

    const closeConfirmationModal = () => {
      if (this.state.isModalPreferenceChecked) {
        localStorage.setItem('showPlsConfirmation', true);
      }
      this.setState({
        showPlsConfirmationModal: false,
        isModalPreferenceChecked: false
      });
    };

    const setModalPreference = e => {
      this.setState({
        isModalPreferenceChecked: !this.state.isModalPreferenceChecked
      });
    };

    const onAgree = e => {
      if (this.state.isModalPreferenceChecked) {
        localStorage.setItem('showPlsConfirmation', true);
      }

      this.setState({
        showPlsConfirmationModal: false,
        isModalPreferenceChecked: false
      });
      return onPurchase(e);
    };

    return (
      <Modal className="pls-purchase-confirmation-modal" show={true}>
        <Modal.Body>
          <div className="text-container">
            <div>
              You are Redeeming an item from the{' '}
              <span className="red-text">Miami</span> WStore
            </div>
            <div>
              Any items purchased in the <span className="red-text">Miami</span>{' '}
              store are valid
              <span className="red-text"> only in Miami </span>
              and <span className="red-text"> can not</span> be used or
              exchanged with any
              <span className="blue-text"> other location</span>
            </div>
            <div className="do-you-accept-text">Do you accept?</div>
          </div>
          <Input
            type="checkbox"
            label="Don't show this again"
            value={this.state.isModalPreferenceChecked}
            onChange={setModalPreference}
          />
          <div className="buttons-container">
            <BtnWithSounds variant="orange" onClick={closeConfirmationModal}>
              DISAGREE
            </BtnWithSounds>
            <BtnWithSounds variant="success" onClick={onAgree}>
              AGREE
            </BtnWithSounds>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const { selectedItem, hidden, onClose, purchaseConfirmation } = this.props;
    const show =
      selectedItem && !hidden && !this.state.showPlsConfirmationModal;
    return (
      <>
        {show && (
          <Modal
            className={`modal-dialog-wstore ${
              purchaseConfirmation ? 'modal-overlay' : ''
            }`}
            show={true}
            onHide={onClose}
          >
            <Modal.Body
              bsPrefix={`modal-body ${getCategoryItemClassName(
                selectedItem.classCode
              )}`}
            >
              <div className="title-container">
                <div className="title">{selectedItem.name}</div>
                <button
                  className="exit-modal-button"
                  type="button"
                  onClick={onClose}
                >
                  <img src={ExitButtonIcon} alt="Close purchase modal" />
                </button>
              </div>
              {this.renderPurchaseBody()}
              <div className="footer-buttons">{this.renderRedeemButton()}</div>
              {purchaseConfirmation && (
                <WStoreConfirmation
                  isQuestItem={false}
                  message="Your purchase was successful!"
                  {...this.props}
                />
              )}
            </Modal.Body>
          </Modal>
        )}
        {this.state.showPlsConfirmationModal &&
          this.renderPlsConfirmationModal()}
      </>
    );
  }
}

WStorePurchaseModal.propTypes = {
  selectedItem: PropTypes.object,
  patronAssets: PropTypes.any,
  onPurchase: PropTypes.func,
  purchaseRequested: PropTypes.bool,
  purchaseConfirmation: PropTypes.bool,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  hidden: PropTypes.bool,
  onClose: PropTypes.func,
  isPurchaseEnabled: PropTypes.func,
  isUber: PropTypes.func
};

export default WStorePurchaseModal;
